import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'; // Import the store
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap';




import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDcvEu2bU2I_KJzH2YBF7Qh5s7TOqqx6BA",
  authDomain: "dermapp-remaster.firebaseapp.com",
  projectId: "dermapp-remaster",
  storageBucket: "dermapp-remaster.firebasestorage.app",
  messagingSenderId: "793458562218",
  appId: "1:793458562218:web:e926925cbc0dcaa5fcacd3",
  measurementId: "G-J3DZG4R85Y"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };

const vueApp = createApp(App);

vueApp.config.globalProperties.$environment = 'production';

// vueApp.config.globalProperties.$baseURL = 'http://localhost:3000';
// vueApp.config.globalProperties.$baseURLPacientes = 'http://localhost:8081';
// vueApp.config.globalProperties.$baseURLDerma = 'http://localhost:8082';
// vueApp.config.globalProperties.$baseURLAdmin = 'http://localhost:8080';

//base urls development
// vueApp.config.globalProperties.$baseURL = 'https://shared.core.dermapp.com/development';
// vueApp.config.globalProperties.$baseURLPacientes = 'https://development.d2sse29elvtl2f.amplifyapp.com';
// vueApp.config.globalProperties.$baseURLDerma = 'https://development.d1hwkdpi02eeb2.amplifyapp.com';
// vueApp.config.globalProperties.$baseURLAdmin = 'https://development.d3qc5ziq02amxn.amplifyapp.com';

// base urls staging
// vueApp.config.globalProperties.$baseURL = 'https://shared.core.dermapp.com/staging';
// vueApp.config.globalProperties.$baseURLPacientes = 'https://staging.d2sse29elvtl2f.amplifyapp.com';
// vueApp.config.globalProperties.$baseURLDerma = 'https://staging.d1hwkdpi02eeb2.amplifyapp.com';
// vueApp.config.globalProperties.$baseURLAdmin = 'https://staging.d3qc5ziq02amxn.amplifyapp.com';

//base urls preprod
// vueApp.config.globalProperties.$baseURL = 'https://shared.core.dermapp.com/preprod';
// vueApp.config.globalProperties.$baseURLPacientes = 'https://preprod.d2sse29elvtl2f.amplifyapp.com';
// vueApp.config.globalProperties.$baseURLDerma = 'https://preprod.d1hwkdpi02eeb2.amplifyapp.com';
// vueApp.config.globalProperties.$baseURLAdmin = 'https://preprod.d3qc5ziq02amxn.amplifyapp.com';

//base urls prod
vueApp.config.globalProperties.$baseURL = 'https://core.dermapp.com';
vueApp.config.globalProperties.$baseURLPacientes = 'https://pacientes.dermapp.com';
vueApp.config.globalProperties.$baseURLDerma = 'https://dermatologos.dermapp.com';
vueApp.config.globalProperties.$baseURLAdmin = 'https://admin.dermapp.com';

vueApp.use(router).use(store).mount('#app');